<!-- 공통 파일 첨부 컴포넌트 (eony, 2022/06/09) -->
<template>
  <div>
    <div class="attach_btn_wrap m_tbl_sch" style="margin-top: -10px">
      <!--
      <v-btn @click="callGallery()">갤러리</v-btn>&nbsp;&nbsp;&nbsp;&nbsp;<v-btn
        @click="callCamera()"
        >카메라</v-btn
      >
      -->
    </div>
    <div>
      <v-list flat class="add-box-list">
        <v-list-item-group>
          <v-list-item v-for="(file, i) in fileList" :key="i" class="px-4">
            <v-list-item-content @click="fileView(file)">
              <v-list-item-title>
                <file-img-icon v-bind:fileType="getFileType(file)" />
                <span v-text="file.rFileNm"></span>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon @click="deleteFile(file)">
              <v-icon>mdi-close</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>
<script>
const bizMOB = window.bizMOB;
/* 첨부파일 추가 컴포넌트 */
import FileImgIcon from '@/components/common/FileImgIcon.vue';
import _file from '@/js/file';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    fileList: [],
    fileSeq: 0,
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA', 'GET_FILE_SEQ', 'GET_PARAMS']),
  },

  methods: {
    callCamera() {
      let self = this;
      bizMOB.System.callCamera({
        _sFileName: 'REQ_' + String(new Date().getTime()).substr(4) + '.jpg',
        _sDirectory: '{external}/bizMOB/',
        _fCallback: res => {
          //alert('카메라 선택 후 res = ' + JSON.stringify(res, '', 2));

          var image = [{ _sSourcePath: res.path }];
          // 리사이즈
          bizMOB.File.resizeImage({
            _aFileList: image,
            _nSampleSize: 1,
            _nCompressRate: 100,
            _nWidth: 1440,
            _bIsCopy: true,
            _sTargetDirectory: '{temporary}/bizMOB/',
            _fCallback: function (resResize) {
              /*
              alert(
                'resResize[카메라 - 리사이즈] = ' +
                  JSON.stringify(resResize, '', 2),
              );
              */
              var resizeImage = [
                { _sSourcePath: resResize.list[0].target_path },
              ];
              bizMOB.File.getInfo({
                _aFileList: resizeImage,
                _fCallback: async function (resizeData) {
                  /*
                  alert(
                    '리사이즈 데이터 resizeData = ' +
                      JSON.stringify(resizeData, '', 2),
                  );
                  */
                  const response = await _file.mobUpload(
                    resizeData.list,
                    '',
                    true,
                    false,
                    self.GET_USER_DATA.ssnEnterCd,
                    self.GET_FILE_SEQ!==''?self.GET_FILE_SEQ:self.fileSeq,
                  );
                  //alert(' fileList response ::: ' + JSON.stringify(response));
                  self.fileSeq = response;
                  self.fileListRefresh();
                },
              });
            },
          });
        },
      });
    },

    callGallery() {
      let self = this;
      bizMOB.System.callGallery({
        _sType: 'image',
        _sMaxCount: String(10),
        _fCallback: function (res) {
          // alert('갤러리 선택 후 res = ' + JSON.stringify(res, '', 2));
          if (res.result == false) {
            return;
          }

          var resizeImage = [];
          var count = 1;
          $.each(res.images, function (i, data) {
            var imageList = [];
            imageList.push({ _sSourcePath: data.uri });
            /*
            alert(
              '갤리러 resize 파일 목록 = ' + JSON.stringify(imageList, '', 2),
            );
            */
            //_file.resizeImage(options, imageList);
            bizMOB.File.resizeImage({
              _aFileList: imageList,
              _nSampleSize: 1,
              _nCompressRate: 100,
              _nWidth: 1440,
              _bIsCopy: true,
              _sTargetDirectory: '{temporary}/bizMOB/',
              _fCallback: function (resResize) {
                /*
                alert(
                  'resResize[카메라 - 리사이즈] = ' +
                    JSON.stringify(resResize, '', 2),
                );

                alert('resResize.list : ' + JSON.stringify(resResize.list));
                */
                resizeImage.push({
                  _sSourcePath: resResize.list[0].target_path,
                });

                //alert('bizMOB.File.getInfo start');

                bizMOB.File.getInfo({
                  _aFileList: resizeImage,
                  _fCallback: async function (resizeData) {
                    /*
                    alert(
                      '리사이즈 데이터 resizeData = ' +
                        JSON.stringify(resizeData, '', 2),
                    );
                    */

                    //alert(self.fileSeq);
                    if (res.images.length === count) {
                      const response = await _file.mobUpload(
                        resizeData.list,
                        '',
                        true,
                        false,
                        self.GET_USER_DATA.ssnEnterCd,
                        self.GET_FILE_SEQ!==''?self.GET_FILE_SEQ:self.fileSeq,
                      );

                      self.fileSeq = response;
                      //alert(self.fileSeq);
                      self.fileListRefresh();
                    }
                    count++;
                  },
                });
              },
            });
          });
        },
      });
    },

    async fileListRefresh() {
      this.options = {
        searchType: 'file',
        enterCd: this.GET_USER_DATA.ssnEnterCd,
        fileSeq:
          this.fileSeq === 0
            ? this.GET_PARAMS.fileSeq === undefined
              ? ''
              : this.GET_PARAMS.fileSeq
            : this.fileSeq,
      };


      if (this.options.fileSeq === '') {
        if (this.GET_FILE_SEQ !== '') {
          this.options.fileSeq  = this.GET_FILE_SEQ;
        }
      }

      this.fileList = await _file.search(this.options);
      if (this.fileList.data !== undefined) {
        this.fileList = this.fileList.data.data;
      }

      if (this.GET_FILE_SEQ !== '') {
        this.$store.commit('SET_FILE_SEQ', this.GET_FILE_SEQ)
      } else {
        this.$store.commit('SET_FILE_SEQ', this.fileSeq === 0
            ? this.GET_PARAMS.fileSeq === undefined
              ? ''
              : this.GET_PARAMS.fileSeq
            : this.fileSeq);
      }


      this.$forceUpdate();
    },

    async deleteFile(file) {
      if (confirm('삭제 하시겠습니까?')) {
        await _file.delete(file.enterCd, file.fileSeq, file.seqNo);
        this.fileListRefresh();
      }
    },

    fileView(files) {
      _file.fileView(files);
    },

    getFileType(file) {
      const fileName = file.rFileNm.split('.');
      return fileName[fileName.length - 1];
    },
  },

  created() {
    this.fileListRefresh();
  },

  components: {
    FileImgIcon,
  },
};
</script>

<style></style>
